module.exports = __webpack_public_path__ + "static/media/stacked-HPA-system-sm.6aa5ee54.png";